module.exports = __webpack_public_path__ + "img/logo-tenc.e071aa48.svg";